import React, { ReactNode } from 'react';

export enum UnderlineTypeProps {
  Always = 'always',
  Hover = 'hover',
  None = 'none'
}

export interface LinkProps {
  children?: ReactNode;
  color?: string;
  underline?: UnderlineTypeProps;
  href?: string;
  target?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}